import { useComposablePage } from '@bnnvara/composable';
import React from 'react';

import withBrandedComposablePage from '../../../hocs/withBrandedComposablePage';
import ComposablePageLayout from '../../../layouts/ComposablePageLayout';
import CategoryPageQuery from './CategoryPage.gql';
import pageData from './CategoryPage.json';
import errorPageData from './CategoryPageNotFound.json';

const CategoryPage = () => {
  const { render } = useComposablePage();
  const content = render(pageData, errorPageData);

  return <ComposablePageLayout>{content}</ComposablePageLayout>;
};

export default withBrandedComposablePage({
  query: CategoryPageQuery,
  isFound: (data) => data.brand.category,
})(CategoryPage);
